 
import React from 'react';
import ComponentWrapper from '../../../components/layout/ComponentWrapper';
import { StudyDesignOverview, StudyDesignArms, StudyCopyBlock } from '../index';
import styled from 'styled-components';
 
 
const ComponentWrapperStyled = styled(ComponentWrapper)`
    >div: nth-child(2) {
        tr td dl dd{
            text-align: left !important;
        }
    }
    .box-green dd {
    > div > div {
        margin: 16px 0;
        }
    }
        .box-gray dd {
    > div > div[class^="StudyDesign__AndConditional-"] {
        margin: 16px 0;
        }
    }
    .bold-key{
     font-weight: 600;
     margin-top:0px !important;
     padding-top:24px;
    }
     .box-gradient{
     dt{
     padding-bottom:0px;
     }
     p{
     margin: 10px auto;
     }
     ul{
     li{
     :last-child{
     margin-bottom:0;
        }
     }
     }
     }
`;
 
const CustomStudyCopyBlockWrap = styled.div`
> div {
    margin-top: -20px;
}
`;
 
const MIBCBFifteen = () => (
 
    <ComponentWrapperStyled>
        <StudyDesignOverview
            title="Study Overview"
            description="Phase 3, open-label, randomized, active-controlled, multicenter study of a neoadjuvant and adjuvant regimen of KEYTRUDA + EV and RC + PLND vs neoadjuvant gem + cis and RC + PLND in <strong>cisplatin-eligible</strong> patients with MIBC (N=808)"
            data={[
                [
                    {  
                        title: 'Patient Eligibility Criteria',
                        description: `
                        <p class="bold-key">Key Inclusion Criteria</p>
                        <p><strong>Patients with previously untreated MIBC</strong> (with predominant urothelial carcinoma histology):</p>
                        <ul>
                            <li>Who were eligible for cisplatin-based chemotherapy</li>
                            <li>Who were candidates for RC + PLND</li>
                        </ul>
                        <p class="bold-key">Key Exclusion Criteria</p>
                        <p>Patients with:</p>
                        <ul>
                            <li>Primary non-bladder urothelial cancer (ie, cancer of the ureter, urethra, or renal pelvis)</li>
                            <li>Active autoimmune disease that required systemic therapy within 2 years of treatment</li>
                            <li>Medical condition that required immunosuppression</li>
                        </ul>
                    `,
                        type: 'box-gradient',
                        colspan: 2
                    }
                ],
                [
                    {
                        type: 'arrow-green',
                        colspan: 2
                    }
                ],
                [
                    {
                        title: 'Randomized 1:1 (N=808)',
                        colspan: 2
                    }
                ],
            ]} />
 
        <StudyDesignArms title="Study Arms" arms={[
            {
                title: "Perioperative KEYTRUDA + EV (n=405)",
                data: [
                    [
                        {
                            title: 'Neoadjuvant Treatment',
                            description: [
                                            {
                                                text: `KEYTRUDA 200 mg<sup>a</sup> on day 1 of each 21‑day cycle for <strong>4 cycles</strong>`,
                                                // textCenter: true
                                            },
                                            {
                                                text: `Enfortumab vedotin-ejfv 1.25 mg/kg on days 1 and 8 of each 21-day cycle for <strong>4 cycles</strong>`,
                                                conditional: 'and',
                                                // textCenter: true
                                            },
                                        ],
                            type: 'box-green'
                        }
                    ],
                    [
                        {
                            type: 'arrow-green'
                        }
                    ],
                    [
                        {
                            title: 'RC + PLND',
                            type: 'box-green'
                        }
                    ],
                    [
                        {
                            type: 'arrow-green'
                        }
                    ],
                    [
                        {
                            title: 'Adjuvant Treatment',
                            description: [
                                            {
                                                text: `KEYTRUDA 200 mg<sup>a</sup> on day 1 of each 21‑day cycle for <strong>13 cycles</strong>`,
                                                // textCenter: true
                                            },
                                            {
                                                text: `Enfortumab vedotin-ejfv 1.25 mg/kg on days 1 and 8 of each 21-day cycle for 5 cycles`,
                                                conditional: 'and',
                                                // textCenter: true
                                            },
                                        ],
                            type: 'box-green'
                        },
                    ],
                    // [
                    //     {
                    //         type: 'arrow-green'
                    //     }
                    // ],
                    // [
                    //     {
                    //         description: `Treatment with KEYTRUDA + EV was continued until completion (17 cycles), disease progression that precluded definitive surgery, disease recurrence in the adjuvant phase, disease progression for those who did not undergo surgery or had incomplete resection and entered the adjuvant phase, or unacceptable toxicity.


                    //         The trial was not designed to isolate the effect of KEYTRUDA in each phase (neoadjuvant or adjuvant) of treatment.`,
                    //         type: 'box-gray'
                    //     }
                    // ]
                ]
            },
            {
                title: "Neoadjuvant Gem + Cis and RC + PLND (n=403)",
                data: [
                    [
                        {
                            title: 'Neoadjuvant Treatment',
                            description: [
                                {
                                    text: `Gemcitabine 1000 mg/m<sup>2</sup> on days 1 and 8 of each 21-day cycle for <strong>4 cycles</strong>`,
                                    // textCenter: true
                                },
                                {
                                    text: `Cisplatin 70 mg/m<sup>2</sup> on day 1 of each 21-day cycle for <strong>4 cycles</strong>`,
                                    conditional: 'and',
                                    // textCenter: true
                                },
                            ],
                             type: 'box-gray'
                        }
                    ],
                    [
                        {
                            type: 'arrow-gray'
                        }
                    ],
                    [
                        {
                            title: 'RC + PLND',
                            type: 'box-gray'
                        }
                    ],
                    [
                        {
                            type: 'arrow-gray'
                        }
                    ],
                     [
                        {
                            title: 'Observation',
                            type: 'box-gray'

                        }
                    ]
                ]
            }
        ]}
        />
 
        <CustomStudyCopyBlockWrap>
            <StudyCopyBlock
                description={`
                    <ul>
                        <li>The trial was not designed to isolate the effect of KEYTRUDA in each phase (neoadjuvant or adjuvant) of treatment.</li>
                        <li>Treatment continued until completion of study medications, disease progression, not undergoing or refusal of RC + PLND, disease recurrence in the adjuvant phase, or unacceptable toxicity.</li>
                        <li>Assessment of tumor status, including CT/MRI, was performed at baseline, within 5 weeks prior to RC + PLND, and at 6 weeks post-radical cystectomy. Following RC + PLND, assessment of tumor status, including cystoscopy and urine cytology for patients who did not undergo surgery, was performed every 12 weeks up to 2 years, and every 24 weeks thereafter.</li>
                    </ul>
                `}
            />
        </CustomStudyCopyBlockWrap>

        <StudyCopyBlock
             title="Stratification"
             description={`
                <ul>
                    <li>PD-L1 status (CPS ≥10 vs <10)</li>
                    <li>Tumor stage (T2N0 vs T3/T4aN0 vs T1-T4aN1)</li>
                    <li>Geographic region (United States vs European Union vs Rest of the World)</li>
                </ul>`}
        />
 
        <StudyCopyBlock
            title="End Points"
            description={`
                <p><strong>Major Efficacy Outcome Measure</strong></p>
                <ul>
                    <li>Event-free survival<sup>b</sup>: EFS is defined as time from randomization to the first of disease progression preventing curative surgery, failure to undergo surgery for participants with muscle invasive residual disease, incomplete surgical resection, local or distant recurrence after surgery, or death.</li>
                </ul>
                <p><strong>Additional Efficacy Outcome Measures</strong></p>
                <ul>
                    <li>Overall Survival (OS)</li>
                    <li>Pathological complete response (pCR) rate<sup>c</sup></li>
                </ul>
            `}
        />
 
        <StudyCopyBlock
            title="Baseline patient characteristics (N=808)"
            description={`
                <ul>
                    <li><strong>Sex:</strong> 81% male</li>
                    <li><strong>Median age:</strong> 66 years (range: 35 to 85 years)</li>
                    <li><strong>Race:</strong> White, 80%; Asian, 17%; Multiple, 1.4%; Black or African American, 1.2%; American Indian or Alaska Native, 0.6%; Missing, 0.2%; not Hispanic or Latino, 90%; Hispanic or Latino, 8%; Not reported, 1.7%</li>
                    <li><strong>ECOG PS:</strong> 0: 78%; 1: 22%</li>
                    <li><strong>Pathologic staging and nodal status:</strong> T2N0, 19%; T3/T4aN0, 73%; T1-T4aN1, 8%</li>
                    <li><strong>Histology of tumor:</strong> Pure urothelial carcinoma histology, 89%; Urothelial carcinoma with squamous differentiation, 4.8%; Urothelial carcinoma with glandular differentiation, 2.6%; Urothelial carcinoma with other variant histology, 3.1%</li>
                </ul>
            `}
            footnotes={[
                {
                    label: 'a.',
                    text: "IV infusion over 30 minutes. When administered on the same day, KEYTRUDA was given after EV."
                },
                {
                    label: 'b.',
                    text: "As assessed by BICR."
                },
                {
                    label: 'c.',
                    text: "As assessed by blinded independent pathology review."
                }
            ]}
            definitions={"BICR = blinded independent central review; CT = computed tomography; ECOG PS = Eastern Cooperative Oncology Group performance status; IV = intravenous; MRI = magnetic resonance imaging; N0 = no regional lymph node metastasis; N1 = regional lymph node metastasis; T1 = tumor invades subepithelial connective tissue; T2 = tumor confined to the bladder, but invading into the muscle; T3 = tumor extends through the muscle into the perivesical tissues; T4a = tumor invades beyond the bladder, involving the prostate, uterus, or vagina."}
        />
    </ComponentWrapperStyled>
);
 
export default MIBCBFifteen